import React from 'react';
import { Link } from 'react-router-dom';
import  SimpleReactValidator from 'simple-react-validator';
import Preloader from '../../../core/Preloader';
import { viewData, processData } from '../../../core/HttpAction';
import {permissionCheck} from '../../../core/Permission';
import Nopermission from '../../../core/Nopermission';
const Url='/branch';
const backUrl='/setting'+Url;
 

class AddEditAction extends React.Component {
    constructor(props) {
        super(props); 
        this.state={
            name:'', 
            description:'',
            email:'',
            mobile:'',
            phone:'',
            address:'',
            status:'',
            preloader:this.props.match.params.id?true:false,
            title:this.props.match.params.id?'Edit':'New'
        };
        this.validator = new SimpleReactValidator();
    }


    componentDidMount(){
        if(this.props.match.params.id){
            viewData(Url+'/'+this.props.match.params.id).then((res)=>{
                if(res.data.status===200){
                    let data=res.data.data;
                    this.setState({
                        name:data.name?data.name:'', 
                        description:data.description?data.description:'',
                        email:data.email?data.email:'',
                        mobile:data.mobile?data.mobile:'',
                        phone:data.phone?data.phone:'',
                        address:data.address?data.address:'',
                        status:data.status?data.status:'',
                        preloader:false, 
                    });
                }
            });
        }
    }
 
    setStateFromInput=(event)=> {
        var obj = {};
        obj[event.target.name] = event.target.value;
        this.setState(obj);
    }

    submitForm=()=>{
        if( this.validator.allValid() ){
            const {name,description,email,mobile,phone,address,status}=this.state;
            let params={name,description,email,mobile,phone,address,status};
            let para=this.props.match.params.id?'/'+this.props.match.params.id:'';
            processData(Url+para,params).then((res)=>{
                if(res.data.status===200){
                    this.props.history.push(backUrl);
                } else{
                    const msg =res.data.message?res.data.message:'Please enter required feilds...';                     alert(msg);
                    this.setState({error_status:true,preloader:false});
                }
            });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }
 
  
    render() {
        let {title,preloader,name,description,email,mobile,phone,address,status} = this.state; 
        let role=permissionCheck('roles',title);
        if(!role)
            return <Nopermission/>;
        const nameValid= this.validator.message('Branch Name', name, 'required');
        const descriptionValid= this.validator.message('Branch Description', description, 'required');
        const emailValid= this.validator.message('BranchEmail', email, 'required|email');
        const mobileValid= this.validator.message('Branch Mobile', mobile, 'required|phone');
        const phoneValid= this.validator.message('Branch Phone', phone, 'required|phone');
        const addressValid= this.validator.message('Branch Address', address, 'required');
        const statusValid= this.validator.message('status', status, 'required');
 
        return (
            <div id="page_content_inner" className="uk-width-medium-4-10 uk-container-center">
                <h3 className="heading_b uk-margin-bottom">{title} Branch</h3>
                <div className="md-card">
                    <div className="md-card-content large-padding">
                        <div className="uk-grid" data-uk-grid-margin>
                            <div className="uk-width-medium-1-1"> 
                                <div className={ `md-input-wrapper ${name ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="name">Name<span className="req">*</span></label>
                                    <input type="text" name="name" value={name} onChange={this.setStateFromInput} className={ `md-input ${nameValid ?'md-input-danger':''}`} /> 
                                    {nameValid} 
                                </div>
                            </div>
                            <div className="uk-width-medium-1-1"> 
                                <div className={ `md-input-wrapper ${email ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Email">Email<span className="req">*</span></label>
                                    <input type="text" name="email" value={email} onChange={this.setStateFromInput} className={ `md-input ${emailValid ?'md-input-danger':''}`} /> 
                                    {emailValid} 
                                </div>
                            </div>
                       
                            <div className="uk-width-medium-1-1"> 
                                <div className={ `md-input-wrapper ${mobile ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Mobile">Mobile<span className="req">*</span></label>
                                    <input type="text" name="mobile" value={mobile} onChange={this.setStateFromInput} className={ `md-input ${mobileValid ?'md-input-danger':''}`} /> 
                                    {mobileValid} 
                                </div>
                            </div>
                        </div>

                        <div className="uk-grid" data-uk-grid-margin>
                            <div className="uk-width-medium-1-1"> 
                                <div className={ `md-input-wrapper ${phone ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Phone">Phone<span className="req">*</span></label>
                                    <input type="text" name="phone" value={phone} onChange={this.setStateFromInput} className={ `md-input ${phoneValid ?'md-input-danger':''}`} /> 
                                    {phoneValid} 
                                </div>
                            </div>
                            <div className="uk-width-medium-1-1"> 
                                <div className={ `md-input-wrapper ${address ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Address">Address<span className="req">*</span></label>
                                    <input type="text" name="address" value={address} onChange={this.setStateFromInput} className={ `md-input ${addressValid ?'md-input-danger':''}`} /> 
                                    {addressValid} 
                                </div>
                            </div>
                            <div className="uk-width-medium-1-1"> 
                                <div className={ `md-input-wrapper ${description ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Description">Description<span className="req">*</span></label>
                                    <input type="text" name="description" value={description} onChange={this.setStateFromInput} className={ `md-input ${descriptionValid ?'md-input-danger':''}`} /> 
                                    {descriptionValid} 
                                </div>
                            </div>
                        </div>
                        <div className="uk-grid" data-uk-grid-margin>
                            <div className="uk-width-medium-1-2"> 
                                <div className={ `md-input-wrapper ${status ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="status">Status<span className="req">*</span></label>
                                    <input type="text" name="status" value={status} onChange={this.setStateFromInput} className={ `md-input ${statusValid ?'md-input-danger':''}`} /> 
                                    {statusValid} 
                                </div>
                            </div>
                        </div>
                       
                        <div className="uk-grid">
                            <div className="uk-width-1-1 btn-right-align">
                                <Link to={backUrl} className="md-btn md-btn-small md-btn-danger md-btn-wave-light waves-effect waves-button waves-light">Cancel</Link>
                                <button type="button" onClick={this.submitForm} className="md-btn-small md-btn md-btn-primary md-btn-wave-light waves-effect waves-button waves-light">Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
                { preloader && <Preloader/> }
            </div>  
        );
    }
}
 

export default AddEditAction;


// WEBPACK FOOTER //
// ./src/components/Setting/Branch/addEdit.js